import React, { Component } from 'react';
import { UncontrolledTooltip, UncontrolledButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { toast } from 'react-toastify';
import { useParams } from 'react-router-dom';
import Axios from 'axios';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faBan, faBeer, faTag, faBolt, faPlus, faTimes, faPlusCircle, faQuestionCircle, faFileExcel } from '@fortawesome/free-solid-svg-icons';

import DataTable from '../DataTable';
import { eventRegistrationTypeToString, registrationStateToString, postTypeToString } from '../../../Utils/Converters';
import {
    ALL,
    ACTIVE,
    USER,
    ORGANISER,
    ASSIGNED,
    NOT_ASSIGNED,
    CANCELLED,
    REGISTERED,
    TEACHER
} from '../../../Data/Constants';


function withParams(Component) {
    return props => <Component {...props} params={useParams()} />
}

class EventRegistrationsAdminPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            event: null,
            selection: [],
            deselectAll: false
        };
    }

    componentDidMount() {
        Axios.get(`/admin/events/${this.eventId}`).then(res => {
            this.setState({ event: res });
        });
    }

    eventId = this.props.params.id;

    exportRegistrations() {
        Axios.get(`/admin/events/${this.eventId}/registrations/export`, { responseType: 'blob' })
            .then((response) => {
                const url = window.URL.createObjectURL(new Blob([response]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'registrations.xlsx');
                document.body.appendChild(link);
                link.click();
            });
    }

    onTableChange = (e) => {
        this.setState({ selection: e });
    }

    updateSelectedState(state) {
        Axios.post(`/admin/events/${this.eventId}/registrations/update-state`, {
            state: state,
            ids: this.state.selection
        }).then(() => {
            toast.success("Jelentkezések ("+this.state.selection.length+" db) állapota frissítve.", 10000);
            this.eventRegTable.triggerFetchData();
            this.setState({ deselectAll: !this.state.deselectAll });
        }, err => {
            toast.error(`A jelentkezések állapotának frissítése sikertelen: ${err.errors['']}`, 10000);
        });
    }

    confirmStateChange(state) {
        if(window.confirm("A kijelölt jelentkezések állapota megváltozik erre: "+registrationStateToString(state)+". Biztos vagy benne?")) {
            this.updateSelectedState(state);
        } else {
            toast.success("Nem történt módosítás.");
        }
    }

    columns = [
        {
            header: 'Név',
            id: "name",
            cell: row => {
                  return [USER, ORGANISER, TEACHER].includes(row.type) ? (
                    <NavLink to={`/admin/events/${this.eventId}/registrations/${row.id}`}>
                        {row.userName}
                    </NavLink>
                ) : (
                    <NavLink to={`/admin/events/${this.eventId}/registrations/${row.id}`}>
                        {row.guestName}
                        <span id={`hostName_${row.id}`}>
                <FontAwesomeIcon icon={faQuestionCircle} />
            </span>
                        <UncontrolledTooltip placement="right" target={`hostName_${row.id}`}>
                            {row.userName} vendége
                        </UncontrolledTooltip>
                    </NavLink>
                );
            }
        }
        ,
        {
            header: 'Email cím',
            id: "email",
            cell: row => (
                [USER, ORGANISER, TEACHER].includes(row.type) ?
                    <span>{row.userEmail}</span> :
                    <span>{row.guestEmail}</span>
            )
        },
        {
            header: 'Állapot',
            accessor: 'state',
            cell: row => registrationStateToString(row),
            Filter: ({ filter, onChange }) => (
                <select
                    onChange={event => onChange(event.target.value)}
                    style={{ width: "100%" }}
                    value={filter ? filter.value : { ALL }}>
                    <option value={ACTIVE}>Aktív jelentkezések</option>
                    {new Array(4).fill(0).map((value, index) => {
                        return <option value={index} key={index}>{registrationStateToString(index)}</option>
                    })}
                </select>
            ),
            width: 100
        },
        {
            header: 'Típus',
            id: 'type',
            cell: row => {
                let organiserInfo = row.type === ORGANISER && <small><em> ({postTypeToString(row.post)})</em></small>
                return <span>{eventRegistrationTypeToString(row.type)}{organiserInfo}</span>
            },
            Filter: ({ filter, onChange }) => (
                <select
                    onChange={event => onChange(event.target.value)}
                    style={{ width: "100%" }}
                    value={filter ? filter.value : { ALL }}>
                    <option value={ALL}>Mind mutatása</option>
                    {new Array(5).fill(0).map((value, index) => {
                        return <option value={index} key={index}>{eventRegistrationTypeToString(index)}</option>
                    })}
                </select>
            ),
            width: 150
        },
        {
            header: 'Befizetett összeg',
            accessor: "paidAmount",
            width: 100
        },
        {
            header: 'Korsó',
            id: 'steinCaption',
            cell: row => (
                <span>{
                    row.steinCaption && row.steinCaption.length > 0 ? <span>
                        <FontAwesomeIcon icon={faCheck} />{' '}
                        {row.steinCaption}
                    </span> :
                        <FontAwesomeIcon icon={faBan} />
                }</span>
            ),
            width: 150
        },
        {
            header: 'Létrehozva',
            id: 'creationDate',
            filterable: false,
            cell: row => (
                <span>
                    {new Date(row.creationDate).toLocaleString("hu")}{' '}
                    <small><em>({row.createdByUserName})</em></small>
                </span>
            )
        },
        {
            header: 'Utoljára módosítva',
            id: 'lastModificationDate',
            filterable: false,
            cell: row => {
                if (row.lastModificationDate !== null)
                    return (
                        <span>
                            {new Date(row.lastModificationDate).toLocaleString("hu")}{' '}
                            <small><em>({row.lastModifiedByUserName})</em></small>
                        </span>
                    );
                else return null;
            }
        }
    ];

    render() {
        return (
            <>
                <h1>Jelentkezések{this.state.event && ` - ${this.state.event.name}`}</h1>
                <DataTable
                    ref={r => this.eventRegTable = r}
                    url={`/admin/events/${this.eventId}/registrations`}
                    columns={this.columns}
                    onSelectionChange={this.onTableChange}
                    deselectAll={this.state.deselectAll}
                />
                <NavLink className="btn btn-primary" to={`/admin/events/${this.eventId}/registrations/create`}><FontAwesomeIcon icon={faPlus} /> Új jelentkezés</NavLink>
                <UncontrolledButtonDropdown direction="up">
                    <DropdownToggle caret color="primary">
                        <FontAwesomeIcon icon={faBolt} /> Műveletek
                    </DropdownToggle>
                    <DropdownMenu>
                        <DropdownItem header>Állapot</DropdownItem>
                        <DropdownItem onClick={() => this.confirmStateChange(CANCELLED)}><FontAwesomeIcon icon={faBan} fixedWidth /> Kijelöltek → Lemondva</DropdownItem>
                        <DropdownItem onClick={() => this.confirmStateChange(REGISTERED)}><FontAwesomeIcon icon={faPlusCircle} fixedWidth /> Kijelöltek → Jelentkezve</DropdownItem>
                        <DropdownItem onClick={() => this.confirmStateChange(NOT_ASSIGNED)}><FontAwesomeIcon icon={faTimes} fixedWidth /> Kijelöltek → Nincs beosztva</DropdownItem>
                        <DropdownItem onClick={() => this.confirmStateChange(ASSIGNED)}><FontAwesomeIcon icon={faCheck} fixedWidth /> Kijelöltek → Beosztva</DropdownItem>
                        <DropdownItem header>Befizetés</DropdownItem>
                        {
                            //TODO
                        }
                        <DropdownItem disabled><FontAwesomeIcon icon={faBeer} fixedWidth /> Kijelöltek → Korsó befizetése</DropdownItem>
                        <DropdownItem disabled><FontAwesomeIcon icon={faTag} fixedWidth /> Kijelöltek → Részvételi díj befizetése</DropdownItem>
                        <DropdownItem header>Exportálás</DropdownItem>
                        <DropdownItem onClick={() => this.exportRegistrations()}><FontAwesomeIcon icon={faFileExcel} fixedWidth /> Összes → Exportálás Excel fájlba</DropdownItem>
                    </DropdownMenu>
                </UncontrolledButtonDropdown>
            </>
        );
    }
}

export default withParams(EventRegistrationsAdminPage);
